export default __webpack_public_path__ + "static/media/5.0ff2c4dd.png";